import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _differenceBy from 'lodash/differenceBy';

import { selectUserInfo, selectUserVenues } from 'selectors/general';
import {
  updateStaffAccount as updateStaffAccountAction,
  deleteStaffAccount as deleteStaffAccountAction,
} from './StaffAccounts.saga';
import StaffAccountModal from './StaffAccountModal';
import { syncValidator as validate } from './StaffAccountModal.validator';

const FORM_NAME = 'EDIT_STAFF_ACCOUNT_MODAL';

export const mapStateToProps = (state, ownProps) => {
  const { userId } = selectUserInfo(state);
  const { account } = ownProps;
  const { firstName, lastName, email, venues: accountVenues, role, userId: accountId } = account;
  const userVenues = selectUserVenues(state);

  const venueIds = accountVenues ? accountVenues.map(({ venueId }) => venueId) : [];
  const onlyAccountVenues = _differenceBy(accountVenues, userVenues, 'venueId');
  const venues = [...userVenues, ...onlyAccountVenues];
  const disabledVenueIds = onlyAccountVenues && onlyAccountVenues.map(({ venueId }) => venueId);

  return {
    ...ownProps,
    venues,
    accountType: role,
    isEdit: true,
    isCurrentUser: userId === accountId,
    initialValues: { firstName, lastName, email, venueIds },
    disabledVenueIds,
  };
};

const mapDispatchToProps = {
  updateStaffAccount: updateStaffAccountAction,
  deleteStaffAccount: deleteStaffAccountAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { updateStaffAccount, deleteStaffAccount } = dispatchProps;

  const { account, initialValues } = stateProps;
  const { userId } = account;

  return {
    ...stateProps,
    ...dispatchProps,
    onSubmit: accountValues => updateStaffAccount({ ...accountValues, userId }),
    onDelete: deleteStaffAccount.bind(null, { ...initialValues, userId }),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({ form: FORM_NAME, validate })
)(StaffAccountModal);
